import { render, staticRenderFns } from "./LeaveApprovalSetting.vue?vue&type=template&id=99465dde"
import script from "./LeaveApprovalSetting.vue?vue&type=script&lang=js"
export * from "./LeaveApprovalSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports